export { AnimatedSearch } from "./AnimatedSearch";
